import type { LegacySubscription } from '../../types';

import { hasPlan } from './hasPlan';
import { isTrialExpired } from './isTrialExpired';

export function isExpiredTrialWithNoPlan(legacySubscription: LegacySubscription) {
  const { isCanceled, isBeta } = legacySubscription;
  return isTrialExpired(legacySubscription) && !hasPlan(legacySubscription) && !isCanceled && !isBeta;
}
